import { ErrorHandler, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertErrorHandler implements ErrorHandler {
  handleError(error: Error | any): void {
    // Handle expected errors gracefully
    if (error && typeof error === 'object') {
      const errorName = error.name?.toLowerCase() || '';
      const errorMessage = error.message?.toLowerCase() || '';

      // Handle invalid currency code error
      if (errorName === 'invaid_currency_code') {
        alert(error.message);
        window.location.reload();
        return;
      }

      // Handle push notification permission denied errors gracefully
      // This is expected when:
      // - User denies notification permissions
      // - Browser doesn't support notifications
      // - App is running in insecure context (HTTP)
      if (
        errorName === 'notallowederror' &&
        (errorMessage.includes('registration failed') ||
         errorMessage.includes('permission denied') ||
         errorMessage.includes('permission_denied'))
      ) {
        // Silently ignore - this is expected behavior when notifications are denied
        return;
      }
    }

    // Log only the message to avoid exposing stack traces in production
    console.error('AlertErrorHandler caught an error:', error?.message ?? error);
  }
}
